import React from 'react';
import heroImage from './images/bg-title-page-03.jpg';
import './about.css';
import story from './images/our-story-01.jpg';
import vid from './images/bg-cover-video-02.jpg';
import staf2 from './images/avatar-02.jpg';
import staf3 from './images/avatar-03.jpg';
import staf4 from './images/avatar-04.jpg';
import img1 from "./images/lunch-01.jpg";
import img2 from "./images/lunch-02.jpg";
import img3 from "./images/lunch-03.jpg";
import img4 from "./images/lunch-04.jpg";
import img5 from "./images/lunch-05.jpg";
import img6 from "./images/lunch-06.jpg";
import img7 from "./images/dinner-01.jpg";
import img8 from "./images/dinner-02.jpg";
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div className='About'>
      <section className='hero' style={{backgroundImage: `url(${heroImage})`}}>
        <h1>About Us</h1>
      </section>

      <center>
        <h1 className='italiaan'>Italian Restaurant</h1>
        <h1 className='welcome11'>Our Story</h1>
        <p className='width'>
          Fusce at risus eget mi auctor pulvinar. Suspendisse 
          maximus venenatis pretium. Orci varius natoque penatibus
          et magnis dis parturient montes, nascetur ridiculus mus.
          Aliquam purus purus, lacinia a scelerisque in, luctus 
          vel felis. Donec odio diam, dignissim a efficitur at,
          efficitur et est. Pellentesque semper est ut pulvinar 
          ullamcorper. Class aptent taciti sociosqu ad litora 
          torquent per conubia nostra, per inceptos himenaeos.
          Nulla et leo accumsan, egestas velit ac, fringilla 
          tortor. Sed varius justo sed luctus mattis.
        </p>
      </center>
      
      <br /><br /><hr />

      <center><h1 className='our-A'>Welcome</h1></center>

      <div className="div2">
        <div className="right">
          <h1 className="italian">Italian Restaurant</h1>
          <h1 className="welcome1">Welcome</h1>
          <p className="ptf">
            Donec quis lorem nulla. Nunc eu odio mi. Morbi nec lobortis est...
          </p>
        </div>
        <img src={story} alt="Our story" />
      </div>

      <section className='hero' style={{backgroundImage: `url(${vid})`}}></section>
<section className="specials">
  <h2>Our Specials</h2>
  <div className="specials-container">
    {[img1,img2,img3,img4,img5,img6,img7,img8].map((img, index) => (
      <Link to="/menu" key={index} style={{ textDecoration: 'none', color: 'inherit' }}>
        <div className="special-card">
          <img src={img} alt={`Special ${index+1}`} />
          <h4>Special Dish {index+1}</h4>
          <p>Delicious Italian dish made with fresh ingredients.</p>
        </div>
      </Link>
    ))}
  </div>
</section>
      <br /><br /> 
      <center>
        <i><h1 className='italian'>Meet Our</h1></i>
        <h1 className='welcome11'>Chef</h1>
      </center>

      <div className='staf'>
        <div className='person'>
          <img src={staf2} alt="Peter Heart" />
          <center>
            <h5>Chef</h5>
            <h4>Peter Heart</h4>
            <p>Donec porta eleifend mauris ut effici-tur. Quisque non velit vestibulum, lob-ortis mi eget, rhoncus nunc</p>
          </center>
        </div>
        <div className='person'>
          <img src={staf3} alt="Joysce Bowman" />
          <center>
            <h5>Chef</h5>
            <h4>Joysce Bowman</h4>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ultricies felis a sem tempus tempus.</p>
          </center>
        </div>
        <div className='person'>
          <img src={staf4} alt="Andrew Lawson" />
          <center>
            <h5>Chef</h5>
            <h4>Andrew Lawson</h4>
            <p>Phasellus aliquam libero a nisi varius, vitae placerat sem aliquet. Ut at velit nec ipsum iaculis posuere quis in sapien</p>
          </center>    
        </div>
      </div>


    </div>
  )
}

export default About;
